<template>
  <BaseElSelect
    v-model="syncModel"
    v-bind="$attrs"
    :multiple="multiple"
    :placeholder="showAll? $t('createReservationService.attachService.placeholder'): $t('createReservationService.attachService.search.placeholder')"
    :no-data-text="$t('common.table.empty.text')"
    value-key="id"
    collapse-tags
    :disabled="disabled"
    @change="$emit('change', attachServiceList)"
  >
    <BaseElSelectOption
      v-for="item in displayOptions"
      :key="item.id"
      :label="optionLabel(item)"
      :value="item"
      :disabled="isLegacy(item)"
    />
  </BaseElSelect>
</template>

<script>
import { FindService } from '@/api/service'
import { GetAttachServiceCount, GetAttachService } from '@/api/attachService'
import { mapGetters } from 'vuex'
import { filter } from 'lodash'

export default {
  name: 'AttachServiceSelect',
  props: ['model', 'multiple', 'services', 'showAll', 'disabled'],

  computed: {
    ...mapGetters([
      'shop',
    ]),
    syncModel: {
      get () {
        return this.model
      },
      set (data) {
        this.$emit('update:model', data)
      },
    },
    displayOptions () {
      const selected = Array.isArray(this.syncModel) ? this.syncModel : []
      const selectedIds = new Set(selected.map((i) => i && i.id).filter(Boolean))
      // 服務清單的可選項（隱藏未被選取的已刪除項目），再補回「已被選取但已不在清單」的歷史快照
      const base = filter(this.attachServiceList, (i) => !i.isRemove || selectedIds.has(i.id))
      const baseIds = new Set(base.map((i) => i.id))
      const missingSelected = filter(selected, (sel) => sel && !baseIds.has(sel.id))
      return [...base, ...missingSelected]
    },
  },

  data: () => ({
    attachServiceList: [],
  }),

  watch: {
    async services () {
      await this.findService()
      if (this.syncModel === '' || !this.syncModel) return
      this.syncModel.forEach((item, index) => {
        // 保留已刪除（isRemove）的歷史快照，避免編輯既有預約時被無聲移除
        if (!item.isRemove && !this.attachServiceList.find(el => el.id === item.id)) {
          this.syncModel.splice(index, 1)
        }
      })
    },
  },

  async mounted () {
    if (this.showAll) {
      await this.getAllAttachService()
      return
    }
    await this.findService()
  },

  methods: {
    optionLabel (item) {
      return item.isRemove
        ? `${item.name}${this.$t('createReservationService.attachService.removedSuffix')}`
        : item.name
    },
    // 已刪除或已從此服務移除的附加服務屬歷史快照，僅供顯示/保留，不可再重新選取
    isLegacy (item) {
      return Boolean(item.isRemove) || !this.attachServiceList.find((el) => el.id === item.id)
    },
    async findService () {
      if (!this.services) {
        console.log('no services')
        this.attachServiceList = []
        return
      }
      // FIXME 只移除重複的
      this.attachServiceList = []

      if (!(this.services && this.services.id)) return
      const [res, err] = await FindService({
        shopId: this.shop,
        id: this.services.id,
      })
      if (err) {
        this.$message.error(err.msg)
        return
      }

      this.attachServiceList = res.AppointmentServiceAttaches
    },

    async getAllAttachService () {
      try {
        let max = await this.getAttachServiceCount()
        max = max.data.count
        const options = {
          shopId: this.shop,
          start: 0,
          limit: 100,
        }
        const res = await GetAttachService(options)
        this.attachServiceList = res
        while (this.attachServiceList.length < max) {
          options.start += options.limit
          const res = await GetAttachService(options)
          this.attachServiceList.push(...res)
          console.log('attachServiceList', this.attachServiceList.length)
        }
      } catch (error) {
        console.log(error)
      }
    },

    async getAttachServiceCount () {
      try {
        return await GetAttachServiceCount({ shopId: this.shop })
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
